import React, { useState } from 'react';
import { analyzeExpression } from '../../routing/routes';

const AnalysisComponent = ({ setNotification, permisos }) => {
	return (
		<div style={{ minWidth: '1100px', width: '1100px', margin: 'auto' }}>
			<UtteranceAnalysisComponent setNotification={setNotification} permisos={permisos} />
		</div>
	);
};

export default AnalysisComponent;

const UtteranceAnalysisComponent = ({ setNotification, permisos }) => {
	const [utterance, setUtterance] = useState('');
	const [results, setResults] = useState([]);
	return (
		<div style={{ width: '80%', margin: '40px auto' }}>
			<div align='right'>
				<div className='taby'>Analizar expresiones</div>
			</div>
			<div className='form-container'>
				<h3> Expresión </h3>
				<input onChange={(event) => setUtterance(event.target.value)} style={{ width: '80%' }}>
					{}
				</input>

				{/* Boton para analizar expresiones */}
				{permisos.analizarExpresion && (
					<button
						onClick={() => {
							analyzeExpression(utterance)
								.then((results) => {
									setNotification('mSe analizó la expresión');
									setResults(results);
								})
								.catch(() => {
									setNotification('eHubo un error al analizar la expresión');
								});
						}}
						className='form-button primary-button'>
						Analizar
					</button>
				)}
				<div className='PruebasComponent-UtteranceHeaders'>
					<span className='PruebasComponent-UtteranceCell'>
						<h4>Tipo</h4>
					</span>
					<span className='PruebasComponent-UtteranceCell'>
						<h4>Nombre</h4>
					</span>
					<span className='PruebasComponent-UtteranceCell'>
						<h4>Valor</h4>
					</span>
					<hr />
				</div>
				{results.map((result, index) => {
					return (
						<div className='PruebasComponent-UtteranceHeaders-Result' key={index}>
							<span className='PruebasComponent-UtteranceCell-Result'>
								<h4>{result.esIntent ? 'Intent' : 'Entity'}</h4>
							</span>
							<span className='PruebasComponent-UtteranceCell-Result'>
								<h4>{result.nombre}</h4>
							</span>
							<span className='PruebasComponent-UtteranceCell-Result'>
								<h4>{result.valor}</h4>
							</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};
